import React from 'react'
import ContactForm from './ContactForm'
import Map from './Map'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'

function Contact() {
  return (
    <>
      <Header />
      <ContactForm />
      {/* <Map/> */}
      <Footer />
    </>
  )
}

export default Contact